export default function() {

    $('.js-accordion-header').click(function() {
        $(this).closest('.js-accordion-item').toggleClass('active');
        $(this).siblings('.js-accordion-content').slideToggle();
    })
}